/**
 * Created by Jerker Nord on 2023-10-17.
 */
import {LonerEndCreditContainer} from "./LonerEndCreditContainer";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {gsap, Linear} from "gsap";

export class LonerTickTickBoomEndCredits extends PIXI.Container {

    private static FIRST_NAMES:string[] = ["James", "Mary", "Robert", "Jennifer", "Michael", "Linda", "William", "Patricia", "David", "Elizabeth", "Joseph", "Susan", "Charles", "Jessica", "Daniel", "Sarah", "Matthew", "Karen", "Andrew", "Lisa", "Christopher", "Nancy", "Brian", "Betty", "John", "Lori", "Richard", "Jessica", "Paul", "Cynthia", "Kenneth", "Helen", "Kevin", "Rachel", "George", "Megan", "Mark", "Christine", "Steven", "Marie", "Anthony", "Rebecca", "Donald", "Amanda", "Thomas", "Emily"];
    private static LAST_NAMES:string[] = ["Smith", "Johnson", "Williams", "Jones", "Brown", "Davis", "Miller", "Wilson", "Moore", "Anderson", "Jackson", "White", "Harris", "Martin", "Thompson", "Garcia", "Martinez", "Robinson", "Clark", "Rodriguez", "Lewis", "Lee", "Walker", "Hall", "Allen", "Young", "King", "Wright", "Scott", "Turner", "Adams", "Nelson", "Hill", "Baker", "Lopez", "Harrison", "Cruz", "Powell", "Russell", "Long", "Perez", "Kelly", "Reed", "Cook", "Murphy", "Gonzalez", "Morales", "Wood"];
    private static ROLES:string[] = ["Production Assistant", "Sound Mixer", "Gaffer", "Costume Designer", "Makeup Artist", "Art Director", "Visual Effects Supervisor", "Script Supervisor", "Location Manager", "Stunt Coordinator", "Boom Operator", "Best Boy", "Set Decorator", "Storyboard Artist", "Wardrobe Supervisor", "Casting Director", "Hair Stylist", "Unit Publicist", "Craft Service", "Post-production Coordinator", "Assistant Director", "Camera Operator", "Rigging Grip", "Transportation Captain",
        "Second Unit Director", "Foley Artist", "Dolly Grip", "Sound Editor", "Colorist", "Special Effects Coordinator", "Caterer", "Production Designer", "Editor", "Music Composer", "Still Photographer", "Animal Wrangler", "Art Department Coordinator", "Location Scout", "Assistant Editor", "Production Accountant", "Dialogue Coach", "Costume Supervisor", "ADR Mixer", "Digital Imaging Technician", "Greensman", "Props Master", "First Assistant Camera", "Script Reader", "Clapper Loader",
        "Post-production Supervisor", "Wrangler", "Armorer", "Negative Cutter", "Color Timer", "Key Hair Stylist", "Rigger", "Craft Service Assistant", "On-Set Dresser", "VFX Artist", "Foley Mixer", "Set Painter", "Digital Compositor", "Casting Assistant", "Aerial Coordinator", "Focus Puller", "Transportation Coordinator", "Production Secretary", "Special Effects Assistant", "Assistant Sound Editor", "Film Loader", "Concept Artist", "Grip Assistant", "Costume Assistant", "Seamstress",
        "Prop Assistant", "Production Intern", "Production Runner", "Location Assistant", "Art Department Intern", "Animation Director", "Motion Capture Artist", "Voice Actor", "Music Supervisor", "Foley Recordist", "Rotoscope Artist", "VFX Coordinator", "Set Designer", "Unit Production Manager", "Studio Teacher", "Assistant Location Manager", "Key Makeup Artist", "Costumer", "Scenic Artist", "Concept Designer", "Model Maker", "Set Costumer", "Craft Service Intern",
        "Boom Operator Assistant", "Pyrotechnician", "Visual Effects Artist"];
    private static DELAY_BETWEEN_CREDITS:number = 0.4;
    private static END_CREDIT_SPEED:number = 1;

    private _endCredits:LonerEndCreditContainer[] = [];
    //Don't re-use role until we had 5 different
    private _usedRoles:number[];
    private _endCreditTLs:gsap.core.Timeline[];

    constructor() {
        super();
        this.init();
    }

    private init():void {
        this._usedRoles = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

        this._endCredits = [];
        let endCredit:LonerEndCreditContainer;
        for(let i:number = 0; i < 5; i++) {
            endCredit = new LonerEndCreditContainer();
            endCredit.role = this.randomizeRole();
            endCredit.firstName = this.randomizeFirstName();
            endCredit.lastName = this.randomizeLastName();
            endCredit.sort();
            this._endCredits.push(endCredit);
            endCredit.position.y = 290;
            this.addChild(endCredit);
        }

        this._endCreditTLs = [];
        for(let i:number = 0; i < this._endCredits.length; i++) {
            const scrollTL:gsap.core.Timeline = gsap.timeline({
                paused : true,
                onComplete : (creditIndex:number) => this.creditScrollComplete(i)
            });
            scrollTL.add(gsap.to(this._endCredits[i].position, {
                ease : "none",
                duration : LonerTickTickBoomEndCredits.END_CREDIT_SPEED,
                y : -170
            }));
            this._endCreditTLs.push(scrollTL);
        }
    }

    public startEndCredits():void {
        for(let i:number = 0; i < this._endCreditTLs.length; i++) {
            this._endCreditTLs[i].restart(true).delay(i* LonerTickTickBoomEndCredits.DELAY_BETWEEN_CREDITS);
        }
    }

    private creditScrollComplete(creditIndex:number):void {
        this._endCredits[creditIndex].position.y = 290;
        this._endCreditTLs[creditIndex].restart();
        this._endCredits[creditIndex].role = this.randomizeRole();
        this._endCredits[creditIndex].firstName = this.randomizeFirstName();
        this._endCredits[creditIndex].lastName = this.randomizeLastName();
        this._endCredits[creditIndex].sort();
        //this._endCredits[creditIndex].position.x = 160 - (this._endCredits[creditIndex].width / 2);
    }

    private randomizeFirstName():string {
        return LonerTickTickBoomEndCredits.FIRST_NAMES[MathHelper.randomIntInRange(0, LonerTickTickBoomEndCredits.FIRST_NAMES.length - 1)];
    }

    private randomizeLastName():string {
        return LonerTickTickBoomEndCredits.LAST_NAMES[MathHelper.randomIntInRange(0, LonerTickTickBoomEndCredits.LAST_NAMES.length - 1)];
    }

    private randomizeRole():string {
        let roleValue:number = this._usedRoles[0];
        while(this._usedRoles.includes(roleValue)) {
            roleValue = MathHelper.randomIntInRange(0, LonerTickTickBoomEndCredits.ROLES.length - 1);
        }
        this._usedRoles.shift();
        this._usedRoles.push(roleValue);

        return LonerTickTickBoomEndCredits.ROLES[roleValue];
    }

    public reset():void {
        for(let i:number = 0; i < this._endCredits.length; i++) {
            this._endCreditTLs[i].pause();
            this._endCredits[i].position.y = 290;
        }
    }
}